function getBrandFromUrl() {
  const url = window.location.href.replace(window.location.pathname, "");
  const urlPathname = window.location.pathname;
  if (url.includes("dev.io")) {
    const urlParams = new URLSearchParams(window.location.search);
    const brand = urlParams.get("brand");

    if (brand != null) {
      if (brand.toLowerCase() === "dollar") {
        return "Dollar";
      } else if (brand.toLowerCase() === "thrifty") {
        return "Thrifty";
      } else if (brand.toLowerCase() === "ace") {
        return "Ace";
      } else if (brand.toLowerCase() === "firefly") {
        return "Firefly";
      }
      return "Hertz";
    }
    if (urlPathname.includes("generic-checkin")) {
      return "Generic";
    } else {
      return "Hertz";
    }
  } else if (url != "") {
    if (urlPathname.includes("generic-checkin")) {
      return "Generic";
    } else if (
      url.includes("fireflycarrental") ||
      url.includes("firefly") ||
      url.includes("Firefly")
    ) {
      return "Firefly";
    } else if (url.includes("acerentalcars") || url.includes("ace") || url.includes("Ace")) {
      return "Ace";
    } else if (url.includes("thrifty") || url.includes("Thrifty")) {
      return "Thrifty";
    } else if (url.includes("dollar") || url.includes("Dollar")) {
      return "Dollar";
    } else {
      return "Hertz";
    }
  }
}

export default getBrandFromUrl;
